import React, { createContext, useContext, useState, ReactNode } from "react";

type Anchor = "top" | "left" | "bottom" | "right";

interface DrawerContextType {
  openDrawer: (anchor: Anchor, content: ReactNode) => void;
  closeDrawer: () => void;
  drawerState: {
    anchor: Anchor | null;
    content: ReactNode;
    open: boolean;
  };
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawer must be used within a DrawerProvider");
  }
  return context;
};

export const DrawerProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [drawerState, setDrawerState] = useState({
    anchor: null as Anchor | null,
    content: null as ReactNode,
    open: false,
  });

  const openDrawer = (anchor: Anchor, content: ReactNode) => {
    setDrawerState({ anchor, content, open: true });
    localStorage.setItem("popupOpen", true.toString());
  };

  const closeDrawer = () => {
    setDrawerState({ ...drawerState, open: false });
    localStorage.setItem("popupOpen", false.toString());
  };

  return (
    <DrawerContext.Provider value={{ openDrawer, closeDrawer, drawerState }}>
      {children}
    </DrawerContext.Provider>
  );
};
